import React from 'react';
import {FormView} from '@src/components/_views/configurable/FormView';
import {withRouterApi} from '@src/HOCs/withRouterApi';
import {FormViewProps} from '@src/@types/components/FormViewProps';
import OrderProductForm from './OrderProductForm';
import {IOrderModel} from '@src/@interfaces/models/Order/IOrderModel';
import {Props} from '@src/components/_forms/FormViewForm';
import ShowSameTypeProductsButton from '@views/order-products/ShowSameTypeProductsButton';

export class OrderProductUpdateForm extends FormView {
    cardContainerComponent = React.Fragment;

    protected getFormComponent() {
        return OrderProductForm;
    }

    protected getFormComponentProps(): Partial<Props<IOrderModel>> {
        return {
            ...super.getFormComponentProps(),
            renderAdditionalControls() {
                return <ShowSameTypeProductsButton/>;
            }
        };
    }
}

export default OrderProductUpdateForm.getStoreConnector()(withRouterApi<FormViewProps>(OrderProductUpdateForm));
